import { Link, useLocation } from 'react-router-dom';
import { getStoredUser } from '../api/client';
import { getRoleHomePath } from '../auth/roles';
import {
  GUARDIAN_BLOCKED_REASON,
  GUARDIAN_UNLOCK_REQUIREMENT,
  STAFF_GUARDIAN_NEXT_STEP,
  STUDENT_GUARDIAN_NEXT_STEP,
  SUPPORT_EMAIL_ADDRESS,
  SUPPORT_EMAIL_GUIDANCE,
} from '../copy/onboardingStatus';

function AccessRestrictedPage() {
  const location = useLocation();
  const user = getStoredUser();
  const role = user?.role || null;
  const homePath = getRoleHomePath(role);
  const params = new URLSearchParams(location.search || '');
  const reason = params.get('reason');
  const isGuardianReason = reason === 'guardian';
  const isGuardianBlockedStudent = isGuardianReason && role === 'STUDENT';

  return (
    <div className="page page-shell page-stack">
      <section className="card">
        <p className="eyebrow">Access</p>
        <h1>{isGuardianReason ? 'Waiting for parent verification' : 'Access restricted'}</h1>
        {isGuardianReason ? (
          <>
            <p>{GUARDIAN_BLOCKED_REASON}</p>
            <p>{GUARDIAN_UNLOCK_REQUIREMENT}</p>
            {role === 'STUDENT' ? (
              <p>{STUDENT_GUARDIAN_NEXT_STEP}</p>
            ) : null}
            {(role === 'ADMIN' || role === 'TUTOR') ? (
              <p>{STAFF_GUARDIAN_NEXT_STEP}</p>
            ) : null}
          </>
        ) : (
          <p>This page isn&apos;t available for your account.</p>
        )}
        <p>
          If the invite or access problem continues, email{' '}
          <a href={`mailto:${SUPPORT_EMAIL_ADDRESS}`}>{SUPPORT_EMAIL_ADDRESS}</a>.{' '}
          {SUPPORT_EMAIL_GUIDANCE}
        </p>
        <p>
          {role === 'ADMIN' ? <Link to="/admin/users" className="btn btn-secondary">Open Admin: Users</Link> : null}
          {role === 'TUTOR' ? <Link to="/admin/users/create" className="btn btn-secondary">Open user creation wizard</Link> : null}
        </p>
        {!isGuardianBlockedStudent ? (
          <>
            <p>
              <Link to={homePath} className="btn btn-primary">Go to home</Link>
            </p>
          </>
        ) : null}
      </section>
    </div>
  );
}

export default AccessRestrictedPage;
